import { domainCopy } from '../copy';
import type { ScoreBand } from '../types';
import type { Language } from '../types/language';

/** Band order matches @kk/ui tokens.bandColors. */
export const BAND_ORDER: readonly ScoreBand[] = ['Building', 'Growing', 'Good', 'Great', 'Super'];

/** Building 0–19 · Growing 20–39 · Good 40–59 · Great 60–79 · Super 80–100. */
export function bandIndex(display: number): number {
  const d = Math.min(100, Math.max(0, display));
  return Math.min(4, Math.floor(d / 20));
}

/**
 * **A band's name as a reader sees it** — the wire value in English ("Good"), the glossary's name in Spanish ("Bien").
 * The value on the wire never changes; only what is drawn does.
 */
export function bandLabel(band: ScoreBand, language?: Language): string {
  return domainCopy(language).bands[band];
}

export function bandFor(display: number): ScoreBand {
  return BAND_ORDER[bandIndex(display)] ?? 'Building';
}

/** Lower bound of the band above, or null at Super ("distance to next band" on C07). */
export function nextBandThreshold(display: number): number | null {
  const i = bandIndex(display);
  return i >= 4 ? null : (i + 1) * 20;
}
